(()=>{
  'use strict';
  const root=document.querySelector('.cdj.cdj--category[data-cdj]');
  const bar=root&&root.querySelector('.cdj-browse-controls');
  const nav=bar&&bar.querySelector('.cdj-browse-groups .cdj-chips');
  if(!nav||root.dataset.cdChips)return;
  root.dataset.cdChips='1';

  const stickyTop=()=>parseFloat(getComputedStyle(bar).top)||0;
  const isStuck=()=>bar.classList.contains('is-stuck')||(window.scrollY>0&&bar.getBoundingClientRect().top<=stickyTop()+.5);

  if(!window.fetch||!window.DOMParser||!window.history||!history.pushState)return;
  const reduce=matchMedia('(prefers-reduced-motion: reduce)');
  const wait=ms=>new Promise(done=>setTimeout(done,ms));
  const key=url=>{const u=new URL(url,location.href);return u.origin+u.pathname.replace(/\/$/,'')+'?view='+(u.searchParams.get('view')||'');};
  const links=()=>[...nav.querySelectorAll('a[href]')];
  const linkFor=url=>links().find(a=>key(a.href)===key(url));
  const regionOf=scope=>{
    let box=scope.querySelector('[data-cd-list]');
    if(box)return box;
    const grid=scope.querySelector('.cdj-grid');
    if(!grid)return null;
    box=grid.ownerDocument.createElement('div');
    box.className='cdj-list';box.setAttribute('data-cd-list','');
    const before=[];let node=grid.previousElementSibling;
    while(node&&(node.matches('.cdj-tier-guide,.cdj-cat-note')||node.tagName==='STYLE')){before.unshift(node);node=node.previousElementSibling;}
    grid.before(box);box.append(...before,grid);
    return box;
  };
  const region=regionOf(root);
  if(!region)return;
  const h1=root.querySelector('.cdg-cat-title');
  const crumb=root.querySelector('.cdj-breadcrumb>span:last-child');
  const help=root.querySelector('.cdj-help a[href]');
  const context=root.querySelector('.cdj-sort-context');
  let rawTitle=h1?h1.textContent:'';
  let current=key(location.href);
  const family=links().map(a=>key(a.href)).join('|');
  links().forEach(a=>a.removeAttribute('data-instant'));

  const cache=new Map();
  const TTL=300000;
  const read=html=>{
    const doc=new DOMParser().parseFromString(html,'text/html');
    const sec=doc.querySelector('.cdj.cdj--category[data-cdj]');
    const list=sec&&regionOf(sec);
    const chips=sec&&sec.querySelector('.cdj-browse-groups .cdj-chips');
    if(!list||!chips)throw new Error('cd-chips: page shape');
    if([...chips.querySelectorAll('a[href]')].map(a=>key(a.getAttribute('href'))).join('|')!==family)throw new Error('cd-chips: other family');
    const active=chips.querySelector('[aria-current]'),t=sec.querySelector('.cdg-cat-title'),c=sec.querySelector('.cdj-breadcrumb>span:last-child'),w=sec.querySelector('.cdj-help a[href]');
    return {title:doc.title,h1:t?t.textContent:'',crumb:c?c.textContent:'',list:list.innerHTML,active:active?active.getAttribute('href'):'',help:w?w.getAttribute('href'):'',listStyle:sec.dataset.listStyle||'',landing:sec.dataset.landing||''};
  };
  const load=url=>{
    const k=key(url),hit=cache.get(k);
    if(hit&&Date.now()-hit.at<TTL)return hit.job;
    const job=fetch(url,{credentials:'same-origin'}).then(res=>{if(!res.ok)throw new Error('cd-chips: '+res.status);if(res.redirected&&key(res.url)!==k)throw new Error('cd-chips: moved');return res.text();}).then(read);
    cache.set(k,{at:Date.now(),job});
    job.catch(()=>cache.delete(k));
    return job;
  };
  const warm=url=>{if(key(url)!==current)load(url).catch(()=>{});};

  const setActive=url=>{const k=key(url);root.querySelectorAll('.cdj-chips a[href]').forEach(a=>{if(key(a.href)===k)a.setAttribute('aria-current','page');else a.removeAttribute('aria-current');});};
  const reveal=(a,smooth)=>{
    if(!a||nav.scrollWidth<=nav.clientWidth+1)return;
    const box=nav.getBoundingClientRect(),item=a.getBoundingClientRect();
    nav.scrollTo({left:nav.scrollLeft+(item.left-box.left)-(box.width-item.width)/2,behavior:smooth&&!reduce.matches?'smooth':'auto'});
  };
  const jump=y=>{try{scrollTo({top:y,left:0,behavior:'instant'});}catch(e){scrollTo(0,y);}};
  const hard=(url,o)=>{if(o.push===false)location.reload();else location.assign(url);};

  let ticket=0;
  const go=async(url,o)=>{
    o=o||{};
    const my=++ticket,link=linkFor(url),leftAt=window.scrollY,wasStuck=isStuck();
    links().forEach(a=>a.removeAttribute('aria-busy'));
    if(link){setActive(link.href);reveal(link,true);link.setAttribute('aria-busy','true');}
    root.classList.add('cdj-switching');
    region.setAttribute('aria-busy','true');
    const faded=wait(reduce.matches?0:130);
    let data;
    try{data=await Promise.race([load(url),wait(6000).then(()=>{throw new Error('cd-chips: slow');})]);await faded;}
    catch(e){if(my===ticket)hard(url,o);return;}
    if(my!==ticket)return;
    const titleChanges=!!(h1&&data.h1&&data.h1!==rawTitle);
    if(titleChanges)root.classList.add('cdj-switching-title');
    region.innerHTML=data.list;
    if(titleChanges){h1.textContent=data.h1;rawTitle=data.h1;if(context)context.textContent=data.h1;}
    if(crumb&&data.crumb)crumb.textContent=data.crumb;
    if(help&&data.help)help.setAttribute('href',data.help);
    root.dataset.listStyle=data.listStyle;root.dataset.landing=data.landing;
    if(data.active)setActive(data.active);
    document.title=data.title;
    if(o.push!==false){
      try{history.replaceState(Object.assign({},history.state,{cdChipsY:leftAt}),'');history.pushState({cdChips:1},'',url);}catch(e){location.assign(url);return;}
    }
    current=key(url);
    if(typeof o.y==='number')jump(o.y);
    else if(wasStuck)jump(Math.max(0,region.getBoundingClientRect().top+window.scrollY-stickyTop()-bar.offsetHeight-(parseFloat(getComputedStyle(bar).marginBottom)||0))+2);
    document.dispatchEvent(new CustomEvent('cd:list-swapped',{detail:{root,region,url}}));
    if(typeof window.cdArSwap==='function'){try{window.cdArSwap();}catch(e){}}
    else if(document.documentElement.lang.slice(0,2)==='ar')await wait(140);
    if(my!==ticket)return;
    links().forEach(a=>a.removeAttribute('aria-busy'));
    region.removeAttribute('aria-busy');
    root.classList.remove('cdj-switching','cdj-switching-title');
    reveal(linkFor(data.active||url),true);
    idle();
  };

  nav.addEventListener('click',event=>{
    const a=event.target.closest('a[href]');
    if(!a||!nav.contains(a)||event.defaultPrevented||event.button||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||a.target==='_blank')return;
    if(new URL(a.href).origin!==location.origin)return;
    event.preventDefault();
    if(key(a.href)===current){reveal(a,true);return;}
    go(a.href);
  });
  addEventListener('popstate',event=>{
    if(!root.isConnected||key(location.href)===current)return;
    const state=event.state||{};
    go(location.href,{push:false,y:typeof state.cdChipsY==='number'?state.cdChipsY:undefined});
  });

  const net=navigator.connection;
  const lite=!!(net&&(net.saveData||/2g|3g/.test(net.effectiveType||'')));
  const touch=event=>{const a=event.target.closest&&event.target.closest('a[href]');if(a&&nav.contains(a))warm(a.href);};
  nav.addEventListener('pointerdown',touch,{passive:true});
  nav.addEventListener('touchstart',touch,{passive:true});
  nav.addEventListener('focusin',touch);
  let hover=0;
  nav.addEventListener('mouseover',event=>{clearTimeout(hover);hover=setTimeout(()=>touch(event),65);});
  nav.addEventListener('mouseout',()=>clearTimeout(hover));
  let idleJob=0;
  function idle(){
    if(lite)return;
    clearTimeout(idleJob);
    idleJob=setTimeout(()=>{
      const all=links(),i=all.findIndex(a=>a.hasAttribute('aria-current'));
      [all[i+1],all[i-1]].filter(Boolean).forEach((a,n)=>setTimeout(()=>warm(a.href),n*600));
    },1800);
  }
  if(document.readyState==='complete')idle();else addEventListener('load',idle,{once:true});
})();
(()=>{
  'use strict';
  if(window.cdListGo||!window.fetch||!window.DOMParser||!window.history||!history.pushState)return;
  const SEL='section.cdj.cdj--category[data-cdj]';
  const wrapOf=d=>{const s=d.querySelector(SEL);return s&&s.querySelector('a[data-cdl-level-link]')?s.closest('.shopify-section'):null;};
  const key=url=>{const u=new URL(url,location.href);return u.origin+u.pathname.replace(/\/$/,'')+'?view='+(u.searchParams.get('view')||'');};
  const cache=new Map(),TTL=300000;
  const load=url=>{
    const k=key(url),hit=cache.get(k);
    if(hit&&Date.now()-hit.at<TTL)return hit.job;
    const job=fetch(url,{credentials:'same-origin'}).then(r=>{if(!r.ok)throw new Error('cd-list: '+r.status);if(r.redirected&&key(r.url)!==k)throw new Error('cd-list: moved');return r.text();}).then(h=>{const doc=new DOMParser().parseFromString(h,'text/html');if(!wrapOf(doc))throw new Error('cd-list: page shape');return doc;});
    cache.set(k,{at:Date.now(),job});
    job.catch(()=>{const now=cache.get(k);if(now&&now.job===job)cache.delete(k);});
    return job;
  };
  const wait=ms=>new Promise((yes,no)=>setTimeout(()=>no(new Error('cd-list: slow')),ms));
  const jump=y=>{try{scrollTo({top:y,left:0,behavior:'instant'});}catch(e){scrollTo(0,y);}};
  let ticket=0,current=key(location.href);
  const HOT='#main-content>[data-cd-first]',cssKey=n=>n.tagName==='LINK'?'L'+n.getAttribute('href'):'S'+n.textContent;
  const bring=doc=>{const now=[...document.querySelectorAll(HOT)],have=new Set(now.map(cssKey)),last=now[now.length-1];if(!last)return;let at=last;doc.querySelectorAll(HOT).forEach(n=>{const k=cssKey(n);if(have.has(k))return;have.add(k);const c=document.importNode(n,true);at.after(c);at=c;});};
  const ran=new Set();
  document.querySelectorAll('script').forEach(x=>{const src=x.getAttribute('src');ran.add(src||x.textContent);});
  const go=async(url,o)=>{
    o=o||{};
    const my=++ticket,wrap=wrapOf(document);
    if(!wrap){if(o.push===false)location.reload();else location.assign(url);return;}
    const root=wrap.querySelector(SEL),list=root.querySelector('[data-cdl]');
    root.classList.add('cdl-switching');
    if(o.link){
      const lv=o.link.dataset.level,off=o.link.classList.contains('is-on');
      root.querySelectorAll('a[data-cdl-level-link]').forEach(a=>{const on=!off&&a.dataset.level===lv;a.classList.toggle('is-on',on);if(on)a.setAttribute('aria-current','page');else a.removeAttribute('aria-current');});
    }
    let doc;
    try{doc=await Promise.race([load(url),wait(7000)]);}
    catch(e){if(my===ticket){if(o.push===false)location.reload();else location.assign(url);}return;}
    if(my!==ticket)return;
    const y=window.scrollY,pinned=!!(list&&list.classList.contains('is-pin'));
    const fresh=document.importNode(wrapOf(doc),true),next=fresh.querySelector(SEL);
    next.classList.add('cdl-arriving');
    bring(doc);
    wrap.replaceWith(fresh);
    fresh.querySelectorAll('script').forEach(old=>{
      if(old.type&&!/^(text\/javascript|module)$/i.test(old.type))return;
      const src=old.getAttribute('src'),txt=old.textContent;
      if(src){if(ran.has(src))return;ran.add(src);}
      else if(!/currentScript/.test(txt)){if(ran.has(txt))return;ran.add(txt);}
      const s=document.createElement('script');
      [...old.attributes].forEach(a=>s.setAttribute(a.name,a.value));
      s.textContent=txt;old.replaceWith(s);
    });
    document.title=doc.title;
    if(o.push!==false){
      try{history.replaceState(Object.assign({},history.state,{cdListY:y}),'');history.pushState({cdList:1},'',url);}catch(e){location.assign(url);return;}
    }
    current=key(url);
    const grid=next.querySelector('.cdj-grid'),box=next.querySelector('[data-cdl]');
    if(typeof o.y==='number')jump(o.y);
    else if(pinned&&grid&&box){
      const top=parseFloat(getComputedStyle(box).getPropertyValue('--cdl-top'))||60;
      jump(Math.max(0,grid.getBoundingClientRect().top+window.scrollY-top-132));
    }else jump(y);
    document.dispatchEvent(new CustomEvent('cd:list-swapped',{detail:{root:next,region:next,url}}));
    if(typeof window.cdArSwap==='function'){try{window.cdArSwap();}catch(e){}}
    requestAnimationFrame(()=>requestAnimationFrame(()=>next.classList.remove('cdl-arriving')));
  };
  window.cdListGo=go;
  document.addEventListener('click',e=>{
    const a=e.target.closest&&e.target.closest('a[data-cdl-level-link]');
    if(!a||e.defaultPrevented||e.button||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||a.target==='_blank')return;
    const url=a.dataset.cdlHref||a.href;delete a.dataset.cdlHref;
    if(new URL(url,location.href).origin!==location.origin||!wrapOf(document))return;
    e.preventDefault();
    if(key(url)===current)return;
    go(url,{link:a});
  });
  addEventListener('popstate',e=>{
    if(key(location.href)===current||!wrapOf(document))return;
    const st=e.state||{};
    go(location.href,{push:false,y:typeof st.cdListY==='number'?st.cdListY:undefined});
  });
  const touch=e=>{const a=e.target.closest&&e.target.closest('a[data-cdl-level-link]');if(a&&key(a.href)!==current)load(a.href).catch(()=>{});};
  document.addEventListener('pointerdown',touch,{passive:true});
  document.addEventListener('touchstart',touch,{passive:true});
  const net=navigator.connection,lite=!!(net&&(net.saveData||/2g/.test(net.effectiveType||'')));
  const idle=()=>{
    if(lite)return;
    const seen=new Set();
    [...document.querySelectorAll(SEL+' a[data-cdl-level-link]')].filter(a=>{const k=key(a.href);if(k===current||seen.has(k))return false;seen.add(k);return true;}).forEach((a,n)=>setTimeout(()=>load(a.href).catch(()=>{}),n*900));
  };
  if(document.readyState==='complete')setTimeout(idle,2200);else addEventListener('load',()=>setTimeout(idle,2200),{once:true});
})();
(()=>{
  'use strict';
  if(window.cdStretch)return;window.cdStretch=1;
  if(!('ontouchstart' in window)||!window.CSS||!CSS.supports||!CSS.supports('translate','1px')||CSS.supports('-webkit-touch-callout','none'))return;
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  const MAX=72,K=.55,EASE='cubic-bezier(.2,.9,.3,1)';
  let el=null,px=0,x0=0,y0=0,lock=0,over=0,lastEl=null,lastUp=0;
  const rowOf=t=>{for(let n=t;n&&n.nodeType===1&&n!==document.body;n=n.parentElement){if(n.scrollWidth>n.clientWidth+8){const o=getComputedStyle(n).overflowX;if(o==='auto'||o==='scroll')return n;}}return null;};
  const ends=n=>{const max=n.scrollWidth-n.clientWidth,sl=n.scrollLeft,rtl=getComputedStyle(n).direction==='rtl',lo=rtl?-max:0,hi=rtl?0:max;return{left:sl<=lo+1,right:sl>=hi-1};};
  const show=()=>{const a=Math.abs(over);el.style.translate=a?((over<0?-1:1)*MAX*(1-1/(a*K/MAX+1))).toFixed(1)+'px 0':'';};
  const rest=n=>{n.style.transition='translate .44s '+EASE;n.style.translate='';const end=()=>{n.style.transition='';n.removeEventListener('transitionend',end);};n.addEventListener('transitionend',end);setTimeout(end,560);};
  addEventListener('touchstart',e=>{
    if(el&&el.style.translate){over=0;rest(el);}
    el=e.touches.length===1?rowOf(e.target):null;over=0;lock=0;
    if(!el)return;
    const t=e.touches[0];px=x0=t.clientX;y0=t.clientY;
    if(getComputedStyle(el).overscrollBehaviorX==='auto')el.style.overscrollBehaviorX='contain';
  },{passive:true,capture:true});
  addEventListener('touchmove',e=>{
    if(!el||e.touches.length!==1)return;
    const t=e.touches[0],x=t.clientX,d=x-px;px=x;
    if(!lock){const ax=Math.abs(x-x0),ay=Math.abs(t.clientY-y0);if(ax<6&&ay<6)return;lock=ax>ay?1:2;}
    if(lock!==1)return;
    if(over){const was=over;over+=d;if((was>0)!==(over>0))over=0;}
    else{const en=ends(el);if(d>0&&en.left)over=d;else if(d<0&&en.right)over=d;}
    if(over||el.style.translate){el.style.transition='';show();}
  },{passive:true,capture:true});
  const up=()=>{if(el){lastEl=el;lastUp=performance.now();if(over||el.style.translate){over=0;rest(el);}}el=null;};
  addEventListener('touchend',up,{passive:true,capture:true});
  addEventListener('touchcancel',up,{passive:true,capture:true});
  const seen=new WeakMap();
  document.addEventListener('scroll',e=>{
    const n=e.target;if(!n||n.nodeType!==1||n!==lastEl||el===n)return;
    const now=performance.now(),sl=n.scrollLeft,s=seen.get(n);seen.set(n,{t:now,sl});
    if(now-lastUp>1600||!s||now-s.t>120||now===s.t)return;
    const v=(sl-s.sl)/(now-s.t);if(Math.abs(v)<.9)return;
    const en=ends(n);if(!(en.left&&v<0)&&!(en.right&&v>0))return;
    if(n.style.translate||!n.animate||(n.getAnimations&&n.getAnimations().length))return;
    const b=Math.max(-20,Math.min(20,-v*9));
    n.animate([{translate:'0px 0px'},{translate:b.toFixed(1)+'px 0px',offset:.32},{translate:'0px 0px'}],{duration:460,easing:'cubic-bezier(.25,.8,.3,1)'});
  },{passive:true,capture:true});
})();
